class Countdown {
    constructor(placeholderId, endUnixTime, finishedCallback, onTickCallback, autoRemove = true) {
        this.placeholder = document.querySelector('#' + placeholderId);
        if (!this.placeholder) {
            this.placeholder = document.createElement("div");
            this.placeholder.id = placeholderId;
        }
        if (!this.placeholder.id) {
            this.placeholder.id = "id" + Math.round(Math.random() * 200000);
        }
        if (this.placeholder.init) {
            return;
        } else {
            this.placeholder.init = true;
            this.placeholder.innerHTML = "";
        }
        if (endUnixTime) {
            this.placeholder.dataset.ttl = endUnixTime;
        }
        if (!this.placeholder.dataset.ttl) {
            return null;
        }

        this.finishedCallback = finishedCallback;
        this.onTickCallback = onTickCallback;
        this.autoRemove = autoRemove;

        this.daysContainer = document.createElement("span");
        this.daysContainer.classList.add("days");
        this.hoursContainer = document.createElement("span");
        this.hoursContainer.classList.add("hours");
        this.minutesContainer = document.createElement("span");
        this.minutesContainer.classList.add("minutes");
        this.secondsContainer = document.createElement("span");
        this.secondsContainer.classList.add("seconds");
        this.insertContainers();
        this.start();
        return this;
    }

    insertContainers() {
        this.placeholder.innerHTML = "";
        this.placeholder.appendChild(this.daysContainer);
        this.placeholder.appendChild(this.hoursContainer);
        this.placeholder.appendChild(this.minutesContainer);
        this.placeholder.appendChild(this.secondsContainer);
    }

    set(endUnixTime) {
        this.placeholder.dataset.ttl = endUnixTime;
        this.start();
    }

    update() {
        if (this.autoRemove && !document.querySelector('#' + this.placeholder.id)) {
            this.stop();
        }
        if (this.placeholder.innerHTML === this.finishedCallback) {
            this.insertContainers();
        }
        let delta = (this.placeholder.dataset.ttl * 1000) - app.util.getTime();
        let remainingSeconds = Math.floor((delta / 1000));
        let remainingMinutes = Math.floor(remainingSeconds / 60);
        let remainingDays = Math.floor(remainingSeconds / 60 / 60 / 24);
        let remainingHours = remainingSeconds / 60 / 60 % 24;

        if (typeof this.onTickCallback === 'function') {
            this.onTickCallback(remainingSeconds);
        }
        if (remainingDays > 1) {
            this.daysContainer.classList.remove('hidden');
            this.daysContainer.innerHTML = Math.floor(remainingDays).toString() + ' ' + app.config.translate.days;
        } else if (remainingSeconds >= 0) {
            remainingHours = remainingHours + (remainingDays * 24);
            if (remainingMinutes > 0) {
                this.minutesContainer.classList.remove('hidden');
                this.secondsContainer.innerHTML = this._addLeadingZeros(Math.floor(remainingSeconds % 60).toString(), 2);
            } else {
                this.secondsContainer.innerHTML = this._addLeadingZeros(Math.floor(remainingSeconds % 60).toString(), 2);
            }
            if (remainingHours >= 1) {
                this.hoursContainer.classList.remove('hidden');
                this.minutesContainer.innerHTML = this._addLeadingZeros(Math.floor(remainingMinutes % 60).toString(), 2) + ":";
                this.hoursContainer.innerHTML = this._addLeadingZeros(Math.floor(remainingHours).toString(), 2) + ":";
            } else {
                this.minutesContainer.innerHTML = Math.floor(remainingMinutes % 60).toString() + ":";
                this.hoursContainer.classList.add('hidden');
            }
            this.daysContainer.classList.add('hidden');
        } else {
            if (typeof this.finishedCallback === 'function') {
                this.finishedCallback();
            } else if (typeof this.finishedCallback === 'string') {
                this.placeholder.innerHTML = this.finishedCallback;
                this.placeholder.init = false;
                clearInterval(this.interval);
            }
            this.stop();
        }
    }

    start() {
        this.update();
        if (!this.interval) {
            this.interval = setInterval(() => this.update(), 1000);
        }
    }

    stop() {
        clearInterval(this.interval);
        this.interval = null;
        delete this;
    }

    _addLeadingZeros(number, length) {
        if (number.toString().length >= length) {
            return number;
        }

        return new Array(length).join('0') + number;
    }
}